export const isValidCode = (verificationCode) => {
    const regex = new RegExp('^[0-9]{6}$');
    return regex.test(verificationCode);
};
